/**
 * Production results — field rollup of applied material-balance last_result rows.
 * Type-well / Monte Carlo UI removed; forecast engine is material balance only.
 */
import { Box, Typography } from '@mui/material';
import React from 'react';

import { MaterialBalanceFieldResults } from '@/components/Scenarios/MaterialBalanceFieldResults';

interface ScenarioCalculationsStepProps {
  scenarioId: string;
  readOnly?: boolean;
  skipLoadExisting?: boolean;
  onCalculationComplete?: () => void;
}

export const ScenarioCalculationsStep: React.FC<ScenarioCalculationsStepProps> = ({
  scenarioId,
}) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Production results
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Field total from applied material-balance results, then per-reservoir development passports
        (reserves, wells, relative permeability, forecast, map) for concept review.
      </Typography>
      <MaterialBalanceFieldResults scenarioId={scenarioId} />
    </Box>
  );
};
